/* istanbul ignore file */

import {
  AuthProvider,
  ErrorBoundaryContextProvider,
  SettingsProvider,
  SigninSilentOidc,
  ValidatiePopup,
  withErrorBoundary,
  RouteEvents,
  FeatureProvider
} from "adviesbox-shared";
import React, { ReactElement, useRef, useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import logo from "./assets/adviesbox-logo.svg";
import BerekeningenApp from "./berekeningen-app/BerekeningenApp";
import { customUserConfirmationMessages } from "./confirmation-enum";
import "./styles/style.scss";
import UserDetailsProvider from "./user-details/user-details-provider";

const App = (): ReactElement => {
  const [modalShow, setModalShow] = useState(false);
  const continueRef = useRef<any>(null);

  return (
    <div className="wrapper">
      <ValidatiePopup
        infotekst="browserInfo"
        show={modalShow}
        onHide={(): void => {
          setModalShow(false);
          continueRef.current(false);
        }}
        onSubmit={(): void => {
          setModalShow(false);
          if (continueRef.current) {
            continueRef.current(true);
          }
        }}
        navigatiepopup
      />

      <ErrorBoundaryContextProvider>
        <BrowserRouter
          getUserConfirmation={(message: string, callback: (ok: boolean) => void): void => {
            if (customUserConfirmationMessages[message as customUserConfirmationMessages]) return;
            continueRef.current = callback;
            setModalShow(true);
          }}
        >
          <SettingsProvider loadingLogo={logo}>
            <Switch>
              <Route path="/silent-redirect" component={withErrorBoundary(SigninSilentOidc)} />
              <Route
                render={(): ReactElement => (
                  <UserDetailsProvider>
                    <>
                      {/* //todo: please keep in place (disabled because of security finding: P105700-2-15): 
                          <GoogleAnalyticsTracker /> */}
                      <AuthProvider>
                        <FeatureProvider>
                          <RouteEvents>
                            <BerekeningenApp />
                          </RouteEvents>
                        </FeatureProvider>
                      </AuthProvider>
                    </>
                  </UserDetailsProvider>
                )}
              />
            </Switch>
          </SettingsProvider>
        </BrowserRouter>
      </ErrorBoundaryContextProvider>
    </div>
  );
};

App.displayName = "App";

export default withErrorBoundary(App);
